export { default } from './es/icons/FolderClosedTwoTone';